module.exports = __webpack_public_path__ + "static/media/caution.dd2c6493.svg";